import { getPagePath, trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import { ROLES } from '../constants';

import ContactUsHeader from './ContactUsHeader';

const InitView = () => {
  const handleRoleClick = () => {
    window.location = getPagePath('support-contact-form');
  };

  return (
    <div className="contact-us-form__fields">
      <ContactUsHeader isInvisible />
      {ROLES.map(role => (
        <Button
          dataTest={`${role}-button`}
          key={role}
          color="primary"
          size="large"
          fullWidth
          onClick={handleRoleClick}
          className="contact-us-form__button"
        >
          {trans(`contact-us.${role}`)}
        </Button>
      ))}
      <Button
        color="primary"
        size="large"
        fullWidth
        className="contact-us-form__button"
        target="_blank"
        href={getPagePath('externals.landlord-support')}
      >
        {trans(`contact-us.landlord`)}
      </Button>
    </div>
  );
};

export default InitView;
